package modysy.simulation.collision

import modysy.model.GameObject

/** Stores information about the collision of two objects.
  *
  * @param spot The information about the collision. The normal points from first to second. */
case class CollisionPair(
    first: GameObject,
    second: GameObject,
    spot: CollisionSpot
)



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/2d4fb5cd/0/mtv-pr-2018/modysy-product/src/main/scala/modysy/simulation/collision/CollisionPair.scala